import { render, staticRenderFns } from "./NewClass.vue?vue&type=template&id=3fb839ac&scoped=true"
import script from "./NewClass.vue?vue&type=script&lang=js"
export * from "./NewClass.vue?vue&type=script&lang=js"
import style0 from "./NewClass.vue?vue&type=style&index=0&id=3fb839ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb839ac",
  null
  
)

export default component.exports